import React from 'react';
import { connect } from 'react-redux';
import { callService, formatDateDMA } from '../tools';
import { Field, reduxForm, formValueSelector } from 'redux-form';

const selector = formValueSelector('datos-poliza');

const mapState = (state) => {
    return {
    	dataForm : selector(state, 'poliza', 'motor', 'placas', 'inicioVigenciaPolizaDate', 'certificado'),
        initialValues: {
			ramo: state.registro.ramo,
			poliza: state.registro.poliza,
			inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza,
			inicioVigenciaPolizaDate: state.registro.inicioVigenciaPolizaDate,
			certificado: state.registro.certificado,
			motor: state.registro.motor,
			placas: state.registro.placas
        },
		grupo: state.registro.configuracion.grupo,
		motor: state.registro.configuracion.motor,
		certificado: state.registro.configuracion.certificado,
		poliza_valida: state.registro.configuracion.poliza_valida,
    };
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		guardarConfiguracion: (oConfiguracion) => {
        			dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION",  "configuracion": oConfiguracion });
        		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo" : sCode });
		},

		polizaValida: (valida) => {
			dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION_VALIDA", "poliza_valida": valida });
		}
	}
}

const validate = values => {
    const errors = {};
    
    if (!values.poliza) {
        errors.poliza = "Campo requerido.";
    } else if(!/^[a-zA-Z0-9_]*$/i.test(values.poliza)){
		errors.poliza = "Este campo sólo acepta números y letras.";
	}
    
    if (!values.certificado) {
        errors.certificado = "Campo requerido.";
    } else if(values.certificado && values.certificado.length < 8) {
    	errors.certificado = "Este campo no puede ser menor de 8 caracteres.";
	} else if(values.certificado && !/^[a-zA-Z0-9_]*$/i.test(values.certificado)){
		errors.certificado = "Este campo sólo acepta números y letras.";
	}
    
    if (!values.inicioVigenciaPoliza) {
        errors.inicioVigenciaPoliza = "Campo requerido.";
    }

    if (!values.motor && !values.placas) {
        errors.motor = "Campo requerido.";
    }
    
    return errors;
}

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined)? value.replace(/\s/g, '') : '';
	campos[tipo] = texto.toUpperCase();
}

const limpiar = (value) => {
	return (value != undefined)? value.replace(/\s/g, '').toUpperCase() : '';
}

const campo = ({ input, label, max, type, blur, change, meta: { touched, error } }) => {
	return (
	    <div className="input-wrap">
			<label htmlFor={input.name}>{label}</label>
			<span className="input-active">
				<input {...input} type={type} onBlur={blur} onChange={(event) => { change(event); input.onChange(event); }} maxLength={max} />
			</span>
			{ touched && error &&
			    <div className="error-wrap">
			        <div className="msj-error">
			            <p><span>{error}</span></p>
			        </div>
				</div>
			}
		</div>
	)
}

const campoDate =  ({ input, label, type, blur, change, meta: { touched, error, warning } }) => {
	return (
		<div className="input-wrap">
			<label htmlFor={input.name}>{label}</label>
			<span className="clearfix input-active">
				<input {...input} type={type} onBlur={blur} onChange={(event) => { change(event); input.onChange(event); }} className='datepicker-input input-group date' />
			</span>
			{ touched && error &&
			    <div className="error-wrap">
			        <div className="msj-error">
			            <p><span>{error}</span></p>
			        </div>
				</div>
			}
		</div>
	)
}

class PolizaForm extends React.Component {
	
	state = {
		autos: "", vida: "", gm: "", danios: "",
		images: [
			require("../img/icon_autos_off.svg"),
			require("../img/icon_vida_off.svg"),
			require("../img/icon_gastos_off.svg"),
			require("../img/icon_danos_off.svg"),
			require("../img/icon_autos.svg"),
			require("../img/icon_vida.svg"),
			require("../img/icon_gastos.svg"),
			require("../img/icon_danos.svg")
		],
		poliza: "",
		disabledMotor: false,
		disabledPlacas: false
	}
	
	componentWillMount = () => {
		let $this = this;
		$this.setRamo(this.props.initialValues.ramo);
		
		$(function () {
			$('input.datepicker-input').datepicker({
				format: "dd   -   MM   -   yyyy",
				language: "es",
				endDate: "0d",
				autoclose: true,
				disableTouchKeyboard: true
			}).on('hide', $this.handleDateChangeEvent); //.on('changeDate', $this.handleDateChangeEvent);
		});
	}

	handleDateChangeEvent = (ev) => {
		this.resetConfiguracion();
		this.props.change('inicioVigenciaPoliza', ev.format());
		this.props.change('inicioVigenciaPolizaDate', ev.date.getTime());
		
		if(this.props.dataForm.poliza != "") {
			this.validarPoliza({ "poliza": this.props.dataForm.poliza, "inicioVigenciaPolizaDate": ev.date.getTime() });
		}
	}

	resetRamo = () => {
		this.setState({
			autos: this.state.images[0],
			vida: this.state.images[1],
			gm: this.state.images[2],
			danios: this.state.images[3]
		});
	}
	
	resetConfiguracion = () => {
		this.props.guardarConfiguracion({ grupo: false, certificado: false, motor: false, poliza_valida: false, sistema: false });
		this.props.change('certificado', '');
		this.props.change('placas', '');
		this.props.change('motor', '');
	}
	
	setPolizaReal = (sPoliza) => {
		this.setState({polizaReal:sPoliza});
		this.props.change("polizaReal", sPoliza);
	}

	setRamo = (sRamo) => {
		this.resetRamo();
		this.props.change("ramo", sRamo);
		
		switch (sRamo) {
			case "A": this.setState({ "autos": this.state.images[4] }); break;
			case "V": this.setState({ "vida": this.state.images[5] }); break;
			case "G": this.setState({ "gm": this.state.images[6] }); break;
			case "D": this.setState({ "danios": this.state.images[7] }); break;
		}
	}
	
	handleChange = (event) => {
		let tipo = event.target.name;
		
		if(tipo == "poliza" || tipo == "inicioVigenciaPoliza") {
			this.resetConfiguracion();
		}
		
		if(tipo == "certificado" || tipo == "motor" || tipo == "placas") {
			this.props.polizaValida(false);
		}
	}
	
    handleBlur = (event) => {
		let tipo = event.target.name;
		let oForm = this.props.dataForm;
		
		if(tipo == "poliza" && oForm.inicioVigenciaPolizaDate != "" && event.target.value != "") {
			this.resetConfiguracion();
			this.validarPoliza(oForm);
		}

		if(tipo == "certificado" && event.target.value != "") {
			this.validarCertificado(oForm);
		}
		
		if(tipo == "motor" && event.target.value != "") {
			this.validarAuto(oForm);
		}
		
		if(tipo == "placas" && event.target.value != "") {
			this.validarAuto(oForm);
		}
		
		if(tipo == "motor" && event.target.value == "" && oForm.placas != ""  && this.props.poliza_valida == false) {
			this.validarAuto(oForm);
		}
		
		if(tipo == "placas" && event.target.value == "" && oForm.motor != "" && this.props.poliza_valida == false) {
			this.validarAuto(oForm);
		}
    }
	
	validarPoliza = (oForm) => {
		let $this = this;
		$this.props.loader(true);
		
		let llamaServicio = new callService({
		    service: 'utilerias.identificaPoliza',
		    secure: true,
		    data: { poliza: limpiar(oForm.poliza), fecha: formatDateDMA(oForm.inicioVigenciaPolizaDate) }
		}).execute().then((oResult) => {
		    console.log("Respuesta", oResult);
		    $this.props.loader(false);
			$this.setRamo(oResult.ramo);
			$this.setPolizaReal(oResult.numPoliza);
		    $this.props.guardarConfiguracion(oResult);
		}).catch((error) => {
		    console.log("Error", error);
		    $this.props.loader(false);
		    $this.resetConfiguracion();
		    if(error.message.codigoError != "ERROR") {
		        $this.props.alertaCode(error.message.codigoError);    
		    } else {
		        $this.props.alerta(error.message.mensaje);
		    }
		});
	}

	validarAuto = (oForm) => {
		let $this = this;
		$this.props.polizaValida(false);
		$this.props.loader(true);
		
		let llamaServicio = new callService({
		    service: 'utilerias.identificaPolizaAuto',
		    secure: true,
		    data: {
		    	poliza: limpiar(oForm.poliza), motor: limpiar(oForm.motor), placas: limpiar(oForm.placas), fecha: formatDateDMA(oForm.inicioVigenciaPolizaDate)
		    }
		}).execute().then((oResult) => {
		    console.log("Respuesta", oResult);
		    $this.props.loader(false);
		    $this.props.polizaValida(true);
		}).catch((error) => {
		    console.log("Error", error);
		    $this.props.loader(false);
		    if(error.message.codigoError != "ERROR") {
		        $this.props.alertaCode(error.message.codigoError);    
		    } else {
		        $this.props.alerta(error.message.mensaje);
		    }
		});
	}

	validarCertificado = (oForm) => {
		let $this = this;
		$this.props.loader(true);
		
		let llamaServicio = new callService({
		    service: 'utilerias.identificaCertificado',
		    secure: true,
		    data: { poliza: limpiar(oForm.poliza), certificado: limpiar(oForm.certificado), sistema: $this.props.certificado }
		}).execute().then((oResult) => {
		    console.log("Respuesta", oResult);
		    $this.props.loader(false);
		    $this.props.polizaValida(true);
		}).catch((error) => {
		    console.log("Error", error);
		    $this.props.loader(false);
		    if(error.message.codigoError != "ERROR") {
		        $this.props.alertaCode(error.message.codigoError);    
		    } else {
		        $this.props.alerta(error.message.mensaje);
		    }
		});
	}
	
    render() {
		const { handleSubmit, submitting } = this.props;
		
        return <form onSubmit={handleSubmit}>
			<div className="text-content mt-34">
				<div className='datos-wrap row'>
					<div>
						<h5><i><img src={ require("../img/icon-info-poliza.svg") } alt=""/></i>Información de la Póliza</h5>
						<h6 className="mt-25">Ramo</h6>
						<div className="seguros-wrap row">
							<div className="col-md-10 col-md-offset-1 col-xs-12">
								<div className="col-sm-3 col-xs-6 text-center">
									<img src={ this.state.autos } alt="" />
									<span>Autos</span>
								</div>
								<div className="col-sm-3 col-xs-6 text-center">
									<img src={ this.state.vida } alt="" />
									<span>Vida</span>
								</div>
								<div className="col-sm-3 col-xs-6 text-center">
									<img src={ this.state.gm } alt="" />
									<span>Gastos Médicos</span>
								</div>
								<div className="col-sm-3 col-xs-6 text-center">
									<img src={ this.state.danios } alt="" />
									<span>Daños</span>
								</div>
							</div>
							<div className="col-xs-12 mt-70">
								<div className="row">
									<div className="col-md-6 col-xs-12">
									    <Field name="poliza" type="text" component={campo} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios('poliza')} max="14" label="No. póliza o No. referencia" />
									</div>
									<div className="col-md-6 col-xs-12">
										<Field name="inicioVigenciaPoliza" type="text" change={this.handleChange.bind(this)} blur={this.handleBlur.bind(this)}  component={campoDate} label="Fecha inicio de vigencia de la póliza" />
									</div>
								</div>
								{ this.props.grupo && this.props.certificado && 
									<div className="row">
										<div className="col-md-6 col-xs-12">
											<Field name="certificado" type="text" component={campo} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios('certificado')} max="10" label="No. de certificado" />
										</div>
									</div>
								}								
								{ this.props.grupo && this.props.motor && this.props.dataForm.inicioVigenciaPolizaDate != "" &&
									<div className="row">
										<div className="col-md-6 col-xs-12">
											<Field name="motor" type="text" component={campo} disabled={this.state.disabledMotor?"disabled":""} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios('motor')} max="22" label="No. de serie" />
											<Field name="placas" type="text" component={campo} disabled={this.state.disabledPlacas?"disabled":""} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios('placas')} max="12" label="Placas" />
										</div>
									</div>
								}
							</div>
							<Field name="ramo" component="input" type="hidden" />
							<Field name="polizaReal" component="input" type="hidden" />
							<Field name="inicioVigenciaPolizaDate" component="input" type="hidden" />
						</div>
					</div>
				</div>
			</div>
			{ this.props.poliza_valida == true &&
				<button type="submit" onClick={submitting} className="orange-rectangle">Siguiente</button>				
			}
			{ this.props.poliza_valida == false &&
				<button type="button" className="orange-rectangle disabled">Siguiente</button>
			}
			
			<div style={{"display": "none"}}>{ this.state.images.map((item, i) => <img src={item} key={i}/>)}</div>
		</form>
    }
}

PolizaForm = reduxForm({form: 'datos-poliza', validate})(PolizaForm);
export default connect(mapState, mapDispatch)(PolizaForm);


// WEBPACK FOOTER //
// ./src/registro/poliza.frm.js